/** Known coordinator accounts — bootstrap on first login. */
export const DEFAULT_COORDINATORS = [
  { email: 'rajkumar.cordinator@mpsvns.in', name: 'Raj Kumar (Coordinator)' },
];

export function coordinatorSeedPayload(coordinator) {
  return {
    email: coordinator.email.toLowerCase(),
    name: coordinator.name,
    role: 'COORDINATOR',
  };
}
